"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CoreInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _CoreInputSt = require("./CoreInput.st.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _FilterDataProps = require("../../utils/FilterDataProps");
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/internal/WixUiCoreComponents/components/CoreInput/CoreInput.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class CoreInput extends React.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      focus: false
    });
    (0, _defineProperty2.default)(this, "input", void 0);
    (0, _defineProperty2.default)(this, "_extractRef", ref => {
      const {
        inputRef
      } = this.props;
      this.input = ref;
      if (inputRef) {
        inputRef(ref);
      }
    });
    (0, _defineProperty2.default)(this, "handleFocus", event => {
      this.setState({
        focus: true
      });
      this.props.onFocus(event);
    });
    (0, _defineProperty2.default)(this, "handleBlur", event => {
      this.setState({
        focus: false
      });
      this.props.onBlur(event);
    });
  }
  render() {
    const {
      focus
    } = this.state;
    const {
      error,
      disabled,
      prefix,
      suffix,
      style: inlineStyle,
      id
    } = this.props;
    const {
      error: errorProp,
      style: styleProp,
      prefix: prefixProps,
      suffix: suffixProp,
      inputClassName,
      className,
      inputRef,
      ...allOtherProps
    } = this.props;
    return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
      className: (0, _CoreInputSt.st)(_CoreInputSt.classes.root, {
        disabled,
        error: !!error && !disabled,
        focus
      }, className),
      style: inlineStyle
    }, (0, _FilterDataProps.filterDataProps)(this.props), {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 7
      }
    }), prefix, /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
      id: id
    }, allOtherProps, {
      ref: this._extractRef,
      className: (0, _classnames.default)(_CoreInputSt.classes.nativeInput, inputClassName),
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 100,
        columnNumber: 9
      }
    })), suffix);
  }
  focus() {
    this.input.focus();
  }
  blur() {
    this.input.blur();
  }
  select() {
    this.input.select();
  }
  getSelectionStart() {
    return this.input.selectionStart;
  }
  getSelectionEnd() {
    return this.input.selectionEnd;
  }
  setSelectionRange(start, end) {
    this.input.setSelectionRange(start, end);
  }
}
exports.CoreInput = CoreInput;
(0, _defineProperty2.default)(CoreInput, "displayName", 'CoreInput');
(0, _defineProperty2.default)(CoreInput, "defaultProps", {
  type: 'text',
  onFocus: () => null,
  onBlur: () => null,
  onChange: () => null
});
//# sourceMappingURL=CoreInput.js.map